import { eventHistoryController } from '@/apis/core';
import { humanizeAuthenticatedUser } from '@/utils/string';

export const getAuthenticatedUserSuggestions = async (value: string) => {
  const suggestions =
    await eventHistoryController.getAuthenticatedUserSuggestions({
      prefix: value,
    });
  return suggestions.map((suggestion) =>
    humanizeAuthenticatedUser(suggestion.identifier)
  );
};
